export const ESCAPE_KEY = 'Escape';
